/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { Grid, Icon, Input, TextArea } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../locales/en-US/descriptors';
import '../../scss/VirtualMeters.scss';

interface IVirtualMeterFormProps {
  name: string;
  description: string;
  invalidMetersSelection: boolean;
  setName(name: string): void;
  setDescription(description: string): void;
}

const VirtualMeterForm = (props: IVirtualMeterFormProps) => {
  const d = descriptors.virtualMeters;
  const [t] = useTranslation();
  const descriptionMaxLength = 240;
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!props.name || !props.description || props.invalidMetersSelection) {
      setShowError(true);
    } else {
      setShowError(false);
    }
  }, [props.name, props.description, props.invalidMetersSelection]);

  const checkForSpecialCharacter = (text: string) =>
    text.replace(new RegExp(/[`@.!#$%^&*()+\-=\[\]{};':"\\|,<>\/?~]/, 'g'), '');

  return (
    <Grid.Column width={8}>
      <div className="virtual-meter-form">
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <h5 className="virtual-meter-form-header">
                {t(d.METERGROUPDETAILS)}
              </h5>
              {showError && (
                <div className="virtual-meter-form-error">
                  <Icon name="badge-info" root="common" />
                  <span>{t(d.VALIDATIONREQUIRED)}</span>
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Input
                label={t(d.METERGROUPNAME)}
                maxLength={20}
                fluid
                value={props.name}
                onChange={(text) =>
                  props.setName(checkForSpecialCharacter(text))
                }
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Input
                label={t(d.DESCRIPTION)}
                fluid
                value={props.description}
                onChange={(text) =>
                  props.setDescription(
                    checkForSpecialCharacter(text).substring(
                      0,
                      descriptionMaxLength
                    )
                  )
                }
                placeholder={t(d.DESCRIPTIONPLACEHOLDER)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    </Grid.Column>
  );
};

export default VirtualMeterForm;
